export default __webpack_public_path__ + "static/media/aw.45fc2c29.svg";